import { ArrowForward, Close, ContentCopy, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Button, M_Fieldset, M_SimpleTable } from "src/M_Components";
import { DangerousGoodsFormField } from "./DangerousGoodsFormField";
import { useState } from "react";

export const DangerousGoodsPages = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  const [pageData, setPageData] = useState({})

  const addPage = () => {
    if(!pageData.Page || !pageData.PageNumber) return

    const currentPages = dataState.DangerousGoodsPages ?? []

    currentPages.push({Page: pageData.Page, PageNumber: pageData.PageNumber})
    setDataState({...dataState, DangerousGoodsPages: currentPages})

    setPageData({})
  }

  const deletePage = (row) => {
    const newPages = dataState?.DangerousGoodsPages?.filter((page) => page.Id !== row.Id)
    setDataState({...dataState, DangerousGoodsPages: newPages})
  }

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ContentCopy style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Pages")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "column"
            }}
          >
            <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center"}}>
              <DangerousGoodsFormField label={t("Page")} type="text" code="Page" data={pageData} setData={setPageData} />
              <DangerousGoodsFormField label={t("PageNumber")} type="number" code="PageNumber" data={pageData} setData={setPageData} />
              <M_Button
                bold
                normal
                hoverEffect
                label={t('Add')}
                labelColor={'var(--color-white)'}
                backgroundColor={'var(--color-green)'}
                borderColor={'var(--color-green)'}
                icon={
                  <img
                    src="/icons/svgsDaNet/plus-square.svg"
                    alt={t('Add')}
                    style={{
                      filter:
                        'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)',
                    }}
                    className="iconCreateBooking"
                  />
                }
                onClick={() => addPage()}
              />
            </div>
            
            <M_SimpleTable
              rows={(dataState['DangerousGoodsPages'] && dataState['DangerousGoodsPages']) || []}
              columns={[
                { header: t('Page'), field: "Page" },
                { header: t('PageNumber'), field: "PageNumber" },
                {
                  header: '',
                  body: (row) => (
                    <M_Button
                      none
                      icon={<Close style={{ color: 'var(--color-red)' }} />}
                      onClick={() => deletePage(row)}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </>
  )
}